const classSignInResult = {
  path: 'classSignInResult/:pxTrainingClassSignId',
  component: resolve => require(['../../../../components/pages/student_user/classSignInResult'], resolve),
  props: true
}
export default classSignInResult



// WEBPACK FOOTER //
// ./src/router/pages/student_user/classSignInResult/index.js